import ABCyaPhaser from "@abcya/abcya_phaser";
import AContainer from "../../library/ExtendedObjects/AContainer.js";
import AScene from "../../library/ExtendedObjects/AScene.js";

export default class BubbleArea
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, bottomY)
    {
        this.scene = scene;

        this._bottomY = bottomY;
        this.upperY = 270;
        this.bubbleContainer = this.scene.add.container(0, this.bottomY);

        this.dotContainer = this.scene.add.container(98, 0);
        this.dotContainer.dots = [];
        this.dotContainer.dotIndex = 0;
        
        let dotHeight = 50;
        let dotBG = this.scene.addImage(0, 0, "dotBG", this.dotContainer);
        dotBG.setScale(.8);
        this.dotContainer.dots.push(this.scene.addImage(-30, 0, "dot", this.dotContainer));
        this.dotContainer.dots.push(this.scene.addImage(0, 0, "dot", this.dotContainer));
        this.dotContainer.dots.push(this.scene.addImage(30, 0, "dot", this.dotContainer));
        this.dotContainer.height = dotHeight;

        for(let i = 0; i < this.dotContainer.dots.length; i++)
        {
            this.dotContainer.dots[i].tint = 0xC1D3D0;//9EB2AD
        }

        this.tweenDot();
        this.dotContainer.alpha = 0;

        this.hitbox = this.scene.add.image(0, 80).setOrigin(0);
        this.hitbox.setDisplaySize(780, 795);
        this.hitbox.setInteractive();
        this.hitbox.alpha = .2;
        this.scene.input.setDraggable(this.hitbox);
        this.scene.input.dragDistanceThreshold = 5;
        this.dragY_start = 0;
        this.maxTaper = 100;
        this.bubbleSpacing = 25;

        this.dragVelocity = 0;
        this.dragResistance = 1;
        this.numSampleFrames = 5;
        this.sampleFrames = [];

        this.scene.input.on('dragstart', (pointer, gameObject)=>{
            if(this.isDestroyed) return;

            this.dragVelocity = 0;
            this.dragY_start = pointer.y;
        });
        this.scene.input.on('drag', (pointer, gameObject, dragX, dragY)=>{
            if(this.isDestroyed) return;

            this.scene.killTween(this.bubbleContainer);
            let yDelta = (pointer.y-this.dragY_start);
            this.sampleFrames.push(yDelta);
            if(this.sampleFrames.length > this.numSampleFrames) this.sampleFrames.shift();
            let destPosY = this.bubbleContainer.y + yDelta;

            if(this.isOutOfBounds_Bottom(destPosY)) 
            {
                let distOver = this.bottomY - destPosY;
                destPosY = this.bubbleContainer.y + (yDelta * (1-(distOver/this.maxTaper)));
            }
            else if(this.isOutOfBounds_Top(destPosY)) 
            {
                let distOver = (this.bubbleContainer.y + this.bubbleContainer.first.y) - this.upperY;
                if(this.totalHeight < this.bottomY)
                {
                    distOver = this.bubbleContainer.y - this.bottomY;
                }
                destPosY = this.bubbleContainer.y + (yDelta * (1-(distOver/this.maxTaper)));
            }

            this.bubbleContainer.y = destPosY;
            this.dragY_start = pointer.y;
        });
        this.scene.input.on('dragend', (pointer, gameObject)=>{
            if(this.isDestroyed) return;
            
            if(this.isOutOfBounds_Bottom(this.bubbleContainer.y)) 
            {
                this.scene.addTween(this.bubbleContainer, 200, {y: this.bottomY}, Phaser.Math.Easing.Sine.Out);
            }
            else if(this.isOutOfBounds_Top(this.bubbleContainer.y))
            {
                let dest = (this.totalHeight < this.bottomY) ? this.bottomY : this.upperY - this.bubbleContainer.first.y;
                this.scene.addTween(this.bubbleContainer, 200, {y: dest}, Phaser.Math.Easing.Sine.Out);
            }
            else
            {
                let deltaY = (pointer.y-this.dragY_start);
                this.sampleFrames.push(deltaY);

                let deltaTotal = 0;
                if(this.sampleFrames.length > this.numSampleFrames) this.sampleFrames.shift();
                for(let i = 0; i < this.sampleFrames.length; i++)
                {
                    deltaTotal += this.sampleFrames[i]; 
                }
                
                this.dragVelocity = deltaTotal / this.numSampleFrames;
            }
        });
    }

    destroy()
    {
        this.dotContainer.destroy();
        this.bubbleContainer.destroy();

        this.isDestroyed = true;
    }

    get bottomY()
    {
        return this._bottomY;
    }

    set bottomY(value)
    {
        this._bottomY = value;
        this.bubbleContainer.y = value;
        this.hitbox.setDisplaySize(this.scene.size.width, value);
        this.alignBubbles();
    }

    isOutOfBounds_Bottom(destPosY)
    {
        return (destPosY < this.bottomY);
    }

    isOutOfBounds_Top(destPosY)
    {
        return (this.bubbleContainer.y + this.bubbleContainer.first.y) > this.upperY;
    }

    get totalHeight()
    {
        return (-this.bubbleContainer.first.y - this.bubbleContainer.last.y) + this.bubbleContainer.first.height + (this.bubbleContainer.list.length * this.bubbleSpacing);
    }

    update()
    {
        if(this.dragVelocity == 0) return;
        if(this.dragVelocity > 0)
        {
            this.dragVelocity -= this.dragResistance;
            if(this.dragVelocity < 0) this.dragVelocity = 0;
        }
        else
        {
            this.dragVelocity += this.dragResistance;
            if(this.dragVelocity > 0) this.dragVelocity = 0;
        }
        let destPosY = this.bubbleContainer.y + this.dragVelocity;
        if(this.isOutOfBounds_Bottom(destPosY)) 
        {
            this.dragVelocity = 0;
            destPosY = this.bottomY;
        }
        else if(this.isOutOfBounds_Top(destPosY)) 
        {
            this.dragVelocity = 0;
            destPosY = this.upperY - this.bubbleContainer.first.y;
        }
       

        this.bubbleContainer.y = destPosY;
    }

    toggleDotContainer(toggle)
    {
        if (!toggle) {
            this.bubbleContainer.remove(this.dotContainer);
        }
        else {
            this.bubbleContainer.add(this.dotContainer);
            this.alignBubbles();
        }
        this.dotContainer.setVisible(toggle);

        this.scene.killTween(this.dotContainer);
        this.scene.addTween(this.dotContainer, 500, {alpha: toggle ? 1 : 0}, Phaser.Math.Easing.Linear);
    }

    tweenDot()
    {
        this.scene.addTween(this.dotContainer.dots[this.dotContainer.dotIndex], 300, {tint: 0xC1D3D0}, Phaser.Math.Easing.Sine.InOut);

        this.dotContainer.dotIndex++;
        if(this.dotContainer.dotIndex >= 3) this.dotContainer.dotIndex = 0;

        this.scene.addTween(this.dotContainer.dots[this.dotContainer.dotIndex], 300, {tint: 0x9EB2AD, nothing: 0}, Phaser.Math.Easing.Sine.InOut, ()=>{
            this.tweenDot();
        });
    }

    /**
     * @param {string} text 
     */
    sendMessage(left, text, delay=1, onComplete = null, isCorrect)
    {
        if(this.isDestroyed) return;

        this.toggleDotContainer(true);
        this.scene.addDelay(delay, ()=>{
            if(this.isDestroyed) return;

            if (!left) this.scene.playSound("send_new_message");
            else {
                if (isCorrect == null) {
                    this.scene.playSound("receive_new_message");
                } else if (!isCorrect) {
                    this.scene.playSound("incorrect_answer");
                } else {
                    this.scene.playSound("correct_answer");
                }
            }

            let elements = [];
            let happyIndex = text.indexOf('{happy}');
            let sadIndex = text.indexOf('{sad}');

            if(sadIndex != -1)
            {
                elements.push(this.scene.addText(0, 0, text.replace("{sad}", ""), 24, {width: 300}, 1, null, "comfortaa_b"));
                elements.push(this.scene.addImage(0, 0, 'sad'));
            }
            else if(happyIndex != -1)
            {
                elements.push(this.scene.addText(0, 0, text.replace("{happy}", ""), 24, {width: 300}, 1, null, "comfortaa_b"));
                elements.push(this.scene.addImage(0, 0, 'happy'));
            }
            else
            {
                elements.push(this.scene.addText(0, 0, text, 24, {width: 355}, 1, null, "comfortaa_b"));
            }

            this.toggleDotContainer(false);
            this.createBubble(left, elements);
            if(onComplete != null) this.scene.addDelay(500, ()=>{onComplete();});
        });
    }

    sendImages(left, imageNames, delay=1, onComplete = null)
    {
        if(this.isDestroyed) return;

        this.toggleDotContainer(true);
        this.scene.addDelay(delay, ()=>{
            this.toggleDotContainer(false);
            let images = [];
            for(let i = 0; i < imageNames.length; i++)
            {
                let image = ABCyaPhaser.Images.addImage(0, 0, imageNames[i], this.scene, imageNames[i]==='Dollar' ? ABCyaPhaser.Images.LOCALIZATION_ATLAS : ABCyaPhaser.Images.DEFAULT_ATLAS);
                image.setScale(.6);
                images.push(image);
            }

            this.createBubble(left, images);
            if(onComplete != null) this.scene.addDelay(500, ()=>{onComplete();});
        });
    }

    /**
     * @param {Array} gameObjects 
     */
    createBubble(left, gameObjects)
    {
        if(this.isDestroyed) return;

        let bubbleData = left ? {groupX: 50, color: 0xB7E200, scaleX: 1} : {groupX: 718, color: 0x1ABA9B, scaleX: -1};
        let bubbleGroup = this.scene.addContainer(bubbleData.groupX, 0, new AContainer(this.scene));
        bubbleGroup.bubbleData = bubbleData;
        
        let bubbleHeight = gameObjects[0].height * gameObjects[0].scaleY;
        let padding = 18;
        let radius = bubbleHeight * .5 + padding;
        let rect_Gfx = this.scene.add.graphics({ fillStyle: { color:  bubbleData.color} });
        let rect_Shape = new Phaser.Geom.Rectangle((radius * bubbleData.scaleX), -radius * 2, 
            (444 * bubbleData.scaleX) - (radius * (bubbleData.scaleX * 2)), bubbleHeight + padding * 2);

        let spacing = 15;
        let totalWidth = 0;
        
        for(let i = 0; i < gameObjects.length; i++)
        {
            totalWidth += gameObjects[i].width * gameObjects[i].scaleX;
            if(i != 0) totalWidth += spacing;
        }

        let startX = (222 * bubbleData.scaleX) - (totalWidth * .5);
        let curX = startX;

        for(let i = 0; i < gameObjects.length; i++)
        {
            gameObjects[i].x =  curX + (gameObjects[i].width * gameObjects[i].scaleX * .5);
            gameObjects[i].y = -radius;
            curX += (gameObjects[i].width * gameObjects[i].scaleX) + spacing;
        }

        bubbleGroup.height = radius * 2;
        rect_Gfx.fillRectShape(rect_Shape);

        bubbleGroup.add(this.createCircle((radius * bubbleData.scaleX), - radius, bubbleData.color, radius));
        bubbleGroup.add(this.createCircle((444 * bubbleData.scaleX) - (radius * bubbleData.scaleX), -radius, bubbleData.color, radius));
        bubbleGroup.add(rect_Gfx);
        bubbleGroup.add(gameObjects);

        let bubbleTip = this.scene.addImage((radius * bubbleData.scaleX) - 20, 0, "BubbleTip", bubbleGroup);
        bubbleTip.tint = bubbleData.color;
        bubbleTip.scaleX = bubbleData.scaleX;

        this.bubbleContainer.add(bubbleGroup);
        bubbleGroup.setScale(.2);

        this.alignBubbles();
        return bubbleGroup;
    }

    alignBubbles()
    {
        let curHeight = 0;
        while(this.bubbleContainer.list.length > 25)
        {
            let removedBubble = this.bubbleContainer.list.shift();
            removedBubble.destroy();
        }
        for(let i = this.bubbleContainer.list.length-1; i >= 0; i--)
        {
            let child = this.bubbleContainer.list[i];
            this.scene.addTween(child, 500, {y: curHeight, easeParams: [.7, 2], scaleX: 1, scaleY: 1}, "Back");
            curHeight -= child.height + this.bubbleSpacing;
        }
    }

    createCircle(x, y, color, radius)
    {
        let graphics = this.scene.add.graphics({ fillStyle: { color: color } });
        let circle = new Phaser.Geom.Circle(x, y, radius);
        graphics.fillCircleShape(circle);
        return graphics;
    }
}